import styled from 'styled-components';
import { sizes } from 'style';

export const NestContainer = styled.div`
  width: 420px;
  position: relative;
  margin-top: 25px;
  min-height: 470px;

  @media ${sizes.mobileLarge} {
    min-height: 570px;
  }

  @media ${sizes.mediumLargeDesktop} {
    margin-top: -88px;
  }
`;

export const NestSpinner = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
